// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"264":"c04764fdba8b3281f31a","992":"a29ce42e938ed01bd2a9"}[chunkId] + ".chunk.js";
};